import { createStyles, WithStyles, withStyles } from "@material-ui/core";
import * as React from "react";
import { Link as RouterLink } from "react-router-dom";

import { PageActionButton, RelodeTheme, Text } from "../";
import { ArrowLeftIcon } from "../../assets/icons";

const styles = (theme: RelodeTheme) =>
    createStyles({
        root: {
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            padding: theme.spacing(0, 2),
            minWidth: 0, //needed for textOverflow: "ellipsis"
        },
        header: {
            display: "flex",
            flexDirection: "column",
            minWidth: 0, //needed for textOverflow: "ellipsis"
            justifyContent: "center",
        },
        status: {
            paddingTop: theme.spacing(1),
        },
        headerText: {
            whiteSpace: "nowrap",
            overflow: "hidden",
            lineHeight: "normal",
            textOverflow: "ellipsis",
            paddingTop: theme.spacing(1),
            paddingRight: theme.spacing(2),
            display: "inline-block",
        },
        backButton: {
            marginBottom: theme.spacing(2),
            marginRight: theme.spacing(2),
        },
        classOne: {
            flexDirection: "row",
            alignItems: "center",
            width: "100%",
        },
    });

export interface MobilePageActionsProps extends WithStyles<typeof styles> {
    title?: React.ReactNode;
    backUrl?: string;
    children?: React.ReactNode;
    statusLabel?: React.ReactNode;
    className?: string;
}

export const MobilePageActions = withStyles(styles, {
    name: "MobilePageActions",
})((props: MobilePageActionsProps) => {
    const { classes } = props;

    return (
        <div className={classes.root}>
            {!!props.backUrl && (
                <RouterLink to={props.backUrl}>
                    <PageActionButton
                        id="backButton"
                        title="back to previous page"
                        color="primary"
                        className={classes.backButton}
                    >
                        <ArrowLeftIcon />
                    </PageActionButton>
                </RouterLink>
            )}
            <div className={classes.header}>
                {!!props.title ? (
                    <Text variant="h3" className={classes.headerText}>
                        {props.title}
                    </Text>
                ) : null}

                {props.children}
                {props.statusLabel ? (
                    <div className={classes.status}>{props.statusLabel}</div>
                ) : null}
            </div>
        </div>
    );
});
